export { default as headerData } from "./header-data";
export { default as footerData } from "./footer-data";
export { default as ctaData } from "./cta-data";
export { default as ctaDataTwo } from "./cta-data-two";
